import React from "react";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "../../store";
import { useMsal } from "@azure/msal-react";
import { clearUser } from "../../store/authSlice";
import Sidebar from "../../components/Sidebar";
import TokenConsumptionGraph from "../../components/TokenConsumptionGraph";
import "../Dashboard.scss";
import styles from "./tokenConsumption.module.scss";

export default function TokenConsumptionPage(): JSX.Element {
  const user = useSelector((state: RootState) => state?.auth.user);
  const { instance } = useMsal();
  const dispatch = useAppDispatch();

  const onClickLogout = async () => {
    try {
      await instance.logoutPopup({
        postLogoutRedirectUri: "/",
      });
      dispatch(clearUser());
      window.location.href = "/";
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };

  return (
    <div className="dashboard-root">
      <Sidebar
        activeNav="token"
        user={user || undefined}
        onLogout={onClickLogout}
      />
      <main className="main-area">
        <header className="header">
          <div className="header-left">
            <h1 className="page-title">Token Consumption</h1>
          </div>
        </header>

        <div className="scrollContent">
          <div className={styles.content}>
            <TokenConsumptionGraph />
          </div>
        </div>
      </main>
    </div>
  );
}
